"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShadow = exports.getRadius = exports.selectColorOptions = exports.getColor = void 0; // Color Symbols

var get_color_1 = require("./get-color");

Object.defineProperty(exports, "getColor", {
  enumerable: true,
  get: function get() {
    return get_color_1.getColor;
  }
});
Object.defineProperty(exports, "selectColorOptions", {
  enumerable: true,
  get: function get() {
    return get_color_1.selectColorOptions;
  }
}); // Line Symbols

var get_radius_1 = require("./get-radius");

Object.defineProperty(exports, "getRadius", {
  enumerable: true,
  get: function get() {
    return get_radius_1.getRadius;
  }
}); // Plane Symbols

var get_shadow_1 = require("./get-shadow");

Object.defineProperty(exports, "getShadow", {
  enumerable: true,
  get: function get() {
    return get_shadow_1.getShadow;
  }
});